import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CampCareApiService {

    constructor(private http: ApiHttpClient) { }

    public get(campId: camps.Guid): Observable<api.OperationResultValue<camps.CampCareDetails>> {
        return this.http.get<api.OperationResultValue<camps.CampCareDetails>>(`campcare/${campId}`, true);
    }

    public activate(request: camps.ActivateCampCareRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`campcare/activate`, request, true);
    }

    public close(request: camps.CloseCampCareRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`campcare/close`, request, true);
    }

    public generateDays(request: camps.CampCareDaysGenerationRequest): Observable<api.OperationResultValue<camps.CampCareDaysGenerationResult>> {
        return this.http.post<api.OperationResultValue<camps.CampCareDaysGenerationResult>>(`campcare/generatedays`, request, true);
    }

    public saveDay(request: camps.CampCareDaySaveRequest): Observable<api.OperationResultValue<camps.CampCareDayInfo>> {
        return this.http.post<api.OperationResultValue<camps.CampCareDayInfo>>(`campcare/day/save`, request, true);
    }

    public activateDay(request: camps.CampCareDayActivateRequest): Observable<api.OperationResultValue<camps.CampCareDayInfo>> {
        return this.http.post<api.OperationResultValue<camps.CampCareDayInfo>>(`campcare/day/activate`, request, true);
    }

    public archiveDay(request: camps.CampCareDayArchiveRequest): Observable<api.OperationResultValue<camps.CampCareDayInfo>> {
        return this.http.post<api.OperationResultValue<camps.CampCareDayInfo>>(`campcare/day/archive`, request, true);
    }

    public getInfo(campId: camps.Guid): Observable<api.OperationResultValue<camps.CampCareInfo>> {
        return this.http.get<api.OperationResultValue<camps.CampCareInfo>>(`campcare/${campId}/info`, true);
    }
}
